<template>
  <div class="system-pageAddD" id="app" style="overflow-y: scroll;">
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <mt-header title="加班/调休申请单">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div style="width: 21rem; ">
      <div class="userinfoAdd">
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="userName" label="申请人" readonly/>
        </div>
        <mt-cell label="加班开始日期" @click.native="selectStartTime">
          <div style="font-size: 1.2rem;color: black;">{{ startTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!startTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearStartTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <mt-cell label="加班结束日期" @click.native="selectEndTime">
          <div style="font-size: 1.2rem;color: black;">{{ endTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!endTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearEndTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <van-field name="uploader"
                   label="加班时长">
          <template #input>
            <div style="color: black;">{{leaveDays}}小时</div>
          </template>
        </van-field>
        <div >
          <div><label style="font-size: 1.2rem;font-weight: 700;color: #6d9eeb !important;margin-left: 0.133333rem;line-height: 2rem;">调休开始时间(加班)</label></div>
          <mt-cell label="" @click.native="selectRestOverStartTime">
            <div style="font-size: 1.2rem;color: black;margin-left: -20rem;">{{ restOverStartTime }}</div>
            <img
                style="width: 2rem; padding-right: 0.5rem"
                v-if="!restOverStartTime"
                src="@/assets/icons/svg/dateChoose.svg"
            />
            <div class="mint-field-clear" v-else @click.stop="clearRestOverStartTime">
              <i class="mintui mintui-field-error"></i>
            </div>
          </mt-cell>
        </div>
        <div >
          <div><label style="font-size: 1.2rem;font-weight: 700;color: #6d9eeb !important;margin-left: 0.133333rem;line-height: 2rem;">调休结束时间(加班)</label></div>
        <mt-cell label="" @click.native="selectRestOverEndTime">
          <div style="font-size: 1.2rem;color: black;margin-left: -20rem;">{{ restOverEndTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!restOverEndTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearRestOverEndTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        </div>
        <mt-cell label="调休开始时间" @click.native="selectRestStartTime">
          <div style="font-size: 1.2rem;color: black;">{{ restStartTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!restStartTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearRestStartTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <mt-cell label="调休结束时间" @click.native="selectRestEndTime">
          <div style="font-size: 1.2rem;color: black;">{{ restEndTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!restEndTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearRestEndTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <van-field name="uploader"
                   label="审核人员">
          <template #input>
            <div style="color: black;">{{nameuser}}</div>
          </template>
        </van-field>
        <van-field name="uploader" label="附件">
          <template #input>
            <div  class="btn btn-default"style="position: relative; overflow: hidden;
              margin-top: 6px;">
              <i class="glyphicon glyphicon-open"></i> 上传附件
              <input type="file" name="filePath" style="opacity: 0; position: absolute;
               top: 12px; right: 0; " class='inpu' @change="fileListChange">
            </div>
          </template>
        </van-field>
        <van-field name="uploader" label="">
          <template #input>
            <div v-if="fileList.length!=0" style="display: flex; flex-direction: column;">
              <div
                  v-for="(item, idx) in fileList"
                  :key="idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item.attachmentName }}</span><div class="delete-btn" @click.prevent="fileListdel(item)">x</div>
              </div>
            </div>
          </template>
        </van-field>
        <van-field
            label="加班/调休事由"
            class="owntext"
            v-model="processDescribe"
            rows="2"
            autosize
            type="textarea"
            placeholder="请输入加班/调休事由"
            show-word-limit
        />
        <div  style="display: flex; gap: 8px;">
          <div  class="sub" @click.prevent="handelSubmit">提交</div>
          <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
        </div>
      </div>
    </div>
    <!-- 加班开始时间选择 -->
    <van-popup  v-model="startTimeVisible" position="bottom" style="width: 100%;height: 50%;font-size: 200px">
      <van-datetime-picker
          type="datetime"
          title="选择加班开始时间"
          v-model="currentStartDate"
          :min-date="minDate"
          @confirm="onStartTimeConfirm"
          @cancel="startTimeVisible = false"
      />
    </van-popup>
    <!-- 加班结束时间选择 -->
    <van-popup  v-model="endTimeVisible" position="bottom" style="width: 100%;height: 50%;">
      <van-datetime-picker
          v-model="currentEndDate"
          type="datetime"
          title="选择加班结束时间"
          @confirm="onEndTimeConfirm"
          @cancel="endTimeVisible = false"
      />
    </van-popup>
    <!-- 调休开始时间(加班)选择 -->
    <van-popup  v-model="restOverStartTimeVisible" position="bottom" style="width: 100%;height: 50%;font-size: 200px">
      <van-datetime-picker
          type="datetime"
          title="选择调休开始时间(加班)"
          v-model="currentStartDate"
          :min-date="minDate"
          @confirm="onRestOverStartTimeConfirm"
          @cancel="restOverStartTimeVisible = false"
      />
    </van-popup>
    <!-- 调休结束时间(加班)选择 -->
    <van-popup  v-model="restOverEndTimeVisible" position="bottom" style="width: 100%;height: 50%;">
      <van-datetime-picker
          v-model="currentEndDate"
          type="datetime"
          title="选择调休结束时间(加班)"
          @confirm="onRestOverEndTimeConfirm"
          @cancel="restOverEndTimeVisible = false"
      />
    </van-popup>
    <!-- 调休开始时间选择 -->
    <van-popup  v-model="restStartTimeVisible" position="bottom" style="width: 100%;height: 50%;font-size: 200px">
      <van-datetime-picker
          type="datetime"
          title="选择开始时间"
          v-model="currentStartDate"
          :min-date="minDate"
          @confirm="onRestStartTimeConfirm"
          @cancel="restStartTimeVisible = false"
      />
    </van-popup>
    <!--调休结束时间选择 -->
    <van-popup  v-model="restEndTimeVisible" position="bottom" style="width: 100%;height: 50%;">
      <van-datetime-picker
          v-model="currentEndDate"
          type="datetime"
          title="选择结束时间"
          @confirm="onRestEndTimeConfirm"
          @cancel="restEndTimeVisible = false"
      />
    </van-popup>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      minDate: new Date(2024, 11, 1),
      currentStartDate: new Date(),
      currentEndDate: new Date(),
      processDescribe: "",
      userName: "",
      userId:"",
      isLoading: false,
      nameuser: null,//审核人姓名
      userInfo:{},
      startTime:'',			//流程开始时间
      endTime:'',//流程结束时间
      leaveDays:0, //加班时长
      restOverStartTime:'',		//调休--加班开始时间
      restOverEndTime:'',		//调休--加班结束时间
      restStartTime:'',		//调休开始时间
      restEndTime:'',		//调休结束时间
      fileList: [],
      fileIds: [],
      startTimeVisible:false,
      endTimeVisible:false,
      restOverStartTimeVisible:false,	//调休--加班开始时间
      restOverEndTimeVisible:false,		//调休--加班结束时间
      restStartTimeVisible:false,	//调休开始时间
      restEndTimeVisible:false,	//调休结束时间
      route:'',
      item:{},
      processId:'',
    };
  },
  computed: {
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.userName = this.userInfo.userName
    this.userId = this.userInfo.userId
    if(this.userId==this.userInfo.dept.deptmanager){
      await request({
        url: "getFgldName?userId="+this.userId,
        method: "get"
      }).then( response => {
        this.nameuser = response
      })
    }else {
      await request({
        url: "getManagerName?userId="+this.userId,
        method: "get"
      }).then( response => {
        this.nameuser = response
      })
    }
    this.processId = this.$route.query.item==undefined?'':this.$route.query.item.processId
    if(this.processId){
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOverDetail?processId="+this.processId,
        method: "get",
      }).then(response => {
        this.item = response.data
        console.log(this.item)
        this.restOverStartTime = this.item.restOverStartTime,		//调休--加班开始时间
        this.restOverEndTime = this.item.restOverEndTime,		//调休--加班结束时间
        this.restStartTime = this.item.restStartTime,		//调休开始时间
        this.restEndTime = this.item.restEndTime,		//调休结束时间
        this.leaveDays = this.item.procseeDays, //加班时长
        this.processDescribe = this.item.processDescribe,	//流程申请原因内容
        this.startTime = this.item.startTime,			//加班开始时间
        this.endTime = this.item.endTime			//加班结束时间

        if(this.item.proFileid!=""){
          this.fileIds =   this.item.proFileid.split(",")
          request({
            url: "appDocumentFile?fileIds="+this.item.proFileid,
            method: "get"
          }).then(  response => {
            response.forEach(file => {
              this.fileList.push(file)
            });
          })
        }
      })
    }
    this.route =  this.$route.query.route
  },
  watch: {
  },
  methods: {
    fileListChange(event){
      const file = event.target.files[0]
      axios({
        url: process.env.VUE_APP_SSO_URL+"appSavePfile",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {file:file,userId:this.userId}
      }).then(  response => {
        this.fileList.push(response.data)
        this.fileIds.push(response.data.attachmentId)
      })
    },
    fileListdel(attachment){
      this.fileList.splice(this.fileList.indexOf(attachment),1)
      this.fileIds.splice(this.fileIds.indexOf(attachment.attachmentId),1)
    },
    selectStartTime() {
      this.startTimeVisible = true;
    },
    onStartTimeConfirm(value) {
      this.startTime = this.formatDate(value);
      if(new Date(this.endTime).getTime()<new Date(this.startTime).getTime()){
        this.startTimeVisible = true
        Toast({
          message: "加班开始时间大于加班结束时间了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        if(this.endTime!=null&&this.startTime!=null&&this.endTime!=''&&this.startTime!=''){
          // 计算时间差（毫秒）
          const timeDifference = new Date(this.endTime).getTime() - new Date(this.startTime).getTime();
          // 将时间差转换为分钟，再转换为小时，并考虑小时的小数部分
          const totalMinutes = timeDifference / (60 * 1000); // 转换为分钟
          const totalHours = totalMinutes / 60; // 转换为小时
          const fractionalHours = totalHours % 1; // 获取小数部分，代表不足一小时的部分

          // 如果不足一小时的部分大于等于0.5小时（即30分钟），则算作0.5小时，否则算作0小时
          let leaveHours = Math.floor(totalHours); // 整数小时数
          if (fractionalHours >= 0.5) {
            leaveHours += 0.5;
          }
          this.leaveDays = leaveHours
        }
        this.startTimeVisible = false
      }
    },
    // 清除时间
    clearStartTime() {
      if (this.startTime) {
        this.startTime = '';
      }
    },
    selectEndTime() {
      this.endTimeVisible = true;
    },
    onEndTimeConfirm(value) {
      this.endTime = this.formatDate(value);
      if(new Date(this.endTime).getTime()<new Date(this.startTime).getTime()){
        this.endTimeVisible = true
        Toast({
          message: "加班结束时间小于加班开始时间了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        if(this.endTime!=null&&this.startTime!=null&&this.endTime!=''&&this.startTime!=''){
          // 将时间差转换为分钟，再转换为小时，并考虑小时的小数部分
          const timeDifference = new Date(this.endTime).getTime() - new Date(this.startTime).getTime();
          const totalMinutes = timeDifference / (60 * 1000); // 转换为分钟
          let totalHours = totalMinutes / 60; // 转换为小时
          // 获取开始时间的小时数
          var startHour = new Date(this.startTime).getHours();
          // 如果开始时间小于18点，则按一天最多8小时计算
          if (startHour < 18) {
            // 计算总天数
            var days = Math.floor(totalHours / 24);
            // 剩余小时数
            var remainingHours = totalHours % 24;
            // 每天最多8小时
            totalHours = days * 8 + Math.min(remainingHours, 8);
          }
          const fractionalHours = totalHours % 1; // 获取小数部分，代表不足一小时的部分

          // 如果不足一小时的部分大于等于0.5小时（即30分钟），则算作0.5小时，否则算作0小时
          let leaveHours = Math.floor(totalHours); // 整数小时数
          if (fractionalHours >= 0.5) {
            leaveHours += 0.5;
          }
          // 确保最终结果不超过总小时数
          leaveHours = Math.min(leaveHours, totalHours);
          this.leaveDays = leaveHours
        }
        this.endTimeVisible = false
      }
    },
    // 清除时间
    clearEndTime() {
      if (this.endTime) {
        this.endTime = '';
      }
    },
    selectRestOverStartTime() {
      this.restOverStartTimeVisible = true;
    },
    onRestOverStartTimeConfirm(value) {
      this.restOverStartTime = this.formatDate(value);
      if(new Date(this.restOverEndTime).getTime()<new Date(this.restOverStartTime).getTime()){
        this.startTimeVisible = true
        Toast({
          message: "调休开始时间(加班)大于调休结束时间(加班)了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        this.restOverStartTimeVisible = false
      }
    },
    // 清除时间
    clearRestOverStartTime() {
      if (this.restOverStartTime) {
        this.restOverStartTime = '';
      }
    },
    selectRestOverEndTime() {
      this.restOverEndTimeVisible = true;
    },
    onRestOverEndTimeConfirm(value) {
      this.restOverEndTime = this.formatDate(value);
      if(new Date(this.restOverEndTime).getTime()<new Date(this.restOverStartTime).getTime()){
        this.restOverEndTimeVisible = true
        Toast({
          message: "调休结束时间(加班)小于调休开始时间(加班)了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        this.restOverEndTimeVisible = false
      }
    },
    // 清除时间
    clearRestOverEndTime() {
      if (this.restOverEndTime) {
        this.restOverEndTime = '';
      }
    },
    selectRestStartTime() {
      this.restStartTimeVisible = true;
    },
    onRestStartTimeConfirm(value) {
      this.restStartTime = this.formatDate(value);
      if(new Date(this.restEndTime).getTime()<new Date(this.restStartTime).getTime()){
        this.startTimeVisible = true
        Toast({
          message: "调休开始时间大于调休结束时间了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        this.restStartTimeVisible = false
      }
    },
    // 清除时间
    clearRestStartTime() {
      if (this.restStartTime) {
        this.restStartTime = '';
      }
    },
    selectRestEndTime() {
      this.restEndTimeVisible = true;
    },
    onRestEndTimeConfirm(value) {
      this.restEndTime = this.formatDate(value);
      if(new Date(this.restEndTime).getTime()<new Date(this.restStartTime).getTime()){
        this.restEndTimeVisible = true
        Toast({
          message: "调休结束时间(加班)小于调休开始时间(加班)了",
          position: 'top',
          iconClass: "icon icon-success"
        });
      }else {
        this.restEndTimeVisible = false
      }
    },
    // 清除时间
    clearRestEndTime() {
      if (this.restEndTime) {
        this.restEndTime = '';
      }
    },
    formatDate(timestamp) {
      // 创建一个新的Date对象，使用时间戳初始化
      const date = new Date(timestamp);
      // 获取各个时间组件
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      // 组合成所需的格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handelSubmit() {
      if (!this.processDescribe) {
        Toast({
          message: "请填写加班/调休事由"
        });
        return;
      }
      let params = {
        processId : this.processId,
        procseeDays : this.leaveDays, //加班时长
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//流程申请原因内容
        userId : this.userId,			//流程申请人
        startTime : this.startTime,			//加班开始时间
        endTime : this.endTime,			//加班结束时间
        proFileid:this.fileIds.join(','),
        restOverStartTime: this.restOverStartTime,		//调休--加班开始时间
        restOverEndTime: this.restOverEndTime,		//调休--加班结束时间
        restStartTime: this.restStartTime,		//调休开始时间
        restEndTime: this.restEndTime,		//调休结束时间
        statusId:23
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOver",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "提交成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    caogaoSubmit() {
      if (!this.processDescribe) {
        Toast({
          message: "请填写加班/调休事由"
        });
        return;
      }
      let params = {
        processId : this.processId,
        procseeDays : this.leaveDays, //加班时长
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//流程申请原因内容
        userId : this.userId,			//流程申请人
        startTime : this.startTime,			//加班开始时间
        endTime : this.endTime,			//加班结束时间
        proFileid:this.fileIds.join(','),
        restOverStartTime: this.restOverStartTime,		//调休--加班开始时间
        restOverEndTime: this.restOverEndTime,		//调休--加班结束时间
        restStartTime: this.restStartTime,		//调休开始时间
        restEndTime: this.restEndTime,		//调休结束时间
        statusId:22
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appOver",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "保存草稿成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    goBack() {
      this.$router.push(this.route==undefined?"/procedure/addProcedure":this.route);
    }
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 10px;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}

body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.delete-btn {
  color: red;
  cursor: pointer;
  margin-left: 50px;
}
.van-field__control {
  line-height:  2rem;
  font-size: 1.5rem !important;
  margin-top: 10px;
}
.van-field__label {
  span{
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb
  }
  width: 8.2rem;
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.van-field__value {
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.userinfoAdd {
  .idea {
    height: 2.466667rem;
    line-height: 2.466667rem;
    font-size: 1rem;
    background: #efefef;
    color: #646566;
    text-align: center;
    margin-bottom: 0.4rem;
    margin: 0.5rem 0;
  }
  .mint-cell-label {
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb !important;
    margin-left: -20px;
  }
  .owntext {
    padding: 0 !important;

    .van-field__control {
      height: 600px !important;
    }
    .van-field__word-limit {
      height: 75px;
      line-height: 75px;
      margin-bottom: 30px;
    }
  }
  .ownupload {
    margin: 0.5rem 0;
    .van-uploader__preview {
      margin: 10px 10px 10px 0;
      .van-image__error-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-image,
    .van-uploader__upload {
      width: 200px;
      height: 200px;
      border: 1px dashed #ccc;
      .van-uploader__upload-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-delete {
      width: 50px;
      height: 50px;
      .van-uploader__preview-delete-icon {
        font-size: 55px;
      }
    }
  }
  .van-cell {
    align-items: center;
    .van-field__label {
      width: 400px;
      font-size: 60px;
      height: 100px;
      line-height: 100px;
      color: #382c2c;
    }
  }
  .van-field__body {
    input {
      border: none !important;
      color: black;
    }
    textarea {
      padding-left: 30px;
    }
  }
  .sub {
    width: 50%;
    height: 200px;
    line-height: 200px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
}
.system-pageAddD {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  font-family: "PingFangSC-Regular";
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.van-field__error-message {
  line-height: 1.3rem;
}
.custom-list {
  overflow-y: auto; /* 如果内容超出容器高度，则启用垂直滚动 */
  padding: 0;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  background-color: #fff; /* 背景颜色 */
  border-radius: 4px; /* 圆角 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.list-item {
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #ebeef5; /* 分隔线 */
}
.list-item input:disabled {
  opacity: 0.5; /* 置灰效果 */
  cursor: not-allowed; /* 禁止点击的鼠标样式 */
}
.item-content{
  width: 21rem;
}
/* 为title定义样式，这通常是列表项中的主标题 */
.title {
  font-size: 1.213333rem; /* 字体大小 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 字体颜色 */
  margin-bottom: 8px; /* 与副标题之间的间距 */
}

/* 为subtitle定义样式，这通常是列表项中的副标题或额外信息 */
.subtitle {
  font-size: 1.213333rem; /* 字体大小 */
  color: #666; /* 字体颜色 */
}

/* 额外的样式，例如复选框 */
.list-item input[type="checkbox"] {
  margin-top: 0; /* 移除复选框上方的默认间距 */
  margin-right: 16px; /* 复选框与文本之间的间距 */
}
.van-picker__toolbar {
  height: 1.586667rem;
}
.van-picker__cancel, .van-picker__confirm {
  padding: 0 0.213333rem;
  font-size: 1.186667rem;
}
.van-picker__title {
  font-size: 1.213333rem;
  line-height: 1.266667rem;
}
.van-picker-column__item {
  line-height: 1rem
}
.van-picker-column {
  font-size: .8rem;
}
.van-cell {
  font-size: 0.9rem;
  line-height: 1.32rem;
}
.van-field__control:read-only {
  font-size: .8rem;
}
</style>
